module.exports = __webpack_public_path__ + "static/media/practice.078e32ff.svg";